/* eslint-disable import/no-mutable-exports */
import defaultCategories from './default';

const categories = defaultCategories;

export default categories;
